const actions = {
  SET_STATE: 'fundEntities/SET_STATE',
  CHANGE_ENTITY_VALUE: 'fundEntities/CHANGE_ENTITY_VALUE',
  RENDER_FUND_INFO: 'fundEntities/RENDER_FUND_INFO',
}

export default actions
